<template>
  <div class="grid my-5">
    <div>
        <Toast />

        <div class="bg-white p-4 rounded-md">
            <Steps :model="items" :readonly="false" />
        </div>

        <router-view v-slot="{Component}" class="mt-4" :formData="formObject" @prevPage="prevPage($event)" @nextPage="nextPage($event)" @complete="complete">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import Steps from 'primevue/steps'
export default {
  name: 'ProcesosJuridicosTutelas',
  components: { Steps },
  setup () {
    const router = useRouter()
    const toast = useToast()
    const items = ref([
      {
        label: 'Buscar persona',
        to: 'buscar-persona'
      },
      {
        label: 'Crear persona',
        to: 'datos-persona'
      },
      {
        label: 'Detallado del Proceso',
        to: 'datos-derecho-peticion'
      }
    ])
    const formObject = ref({})
    const nextPage = (event) => {
      console.log('evento--- >', event)
      for (const field in event.formData) {
          formObject.value[field] = event.formData[field]
      }

      router.push(items.value[event.pageIndex + 1].to)
    }
    const prevPage = (event) => {
        router.push(items.value[event.pageIndex - 1].to)
    }
    const complete = () => {
        toast.add({ severity: 'success', summary: 'Order submitted', detail: 'Dear, ' + formObject.value.firstname + ' ' + formObject.value.lastname + ' your order completed.' })
    }
    return {
      items,
      formObject,
      nextPage,
      prevPage,
      complete
    }
  }
}
</script>
<style scoped>
</style>
